import {SearchType} from '../rules/constants';

import {AdvancedRawRuleModel} from '../rules/advancedRaw/model';
import {AttributeHistoryRuleModel} from '../rules/attributeHistory/model';
import {CartRuleModel} from '../rules/cart/model';
import {CategoryIdRuleModel} from '../rules/categoryId/model';
import {CheckoutsRuleModel} from '../rules/checkouts/model';
import {ContentsRuleModel} from '../rules/contents/model';
import {CustomRuleModel} from '../rules/custom/model';
import {DateRuleModel} from '../rules/date/model';
import {ExpirationRuleModel} from '../rules/expiration/model';
import {FileAspectRuleModel} from '../rules/fileAspect/model';
import {FileFormatRuleModel} from '../rules/fileFormat/model';
import {FileFormatFamilyRuleModel} from '../rules/fileFormatFamily/model';
import {FileSizeRuleModel} from '../rules/fileSize/model';
import {KeywordRuleModel} from '../rules/keyword/model';
import {MetadataRuleModel} from '../rules/metadata/model';
import {AIRuleModel} from '../rules/ai';
import {SavedSearchRuleModel} from '../rules/savedSearch/model';
import {UserRuleModel} from '../rules/user/model';
import {VisualRuleModel} from '../rules/visual/model';

export const RuleModelMap = <const>{
	[SearchType.ADVANCED_RAW]: AdvancedRawRuleModel,
	[SearchType.ATTRIBUTE_HISTORY]: AttributeHistoryRuleModel,
	[SearchType.CART]: CartRuleModel,
	[SearchType.CATEGORY_ID]: CategoryIdRuleModel,
	[SearchType.CHECKOUTS]: CheckoutsRuleModel,
	[SearchType.CONTENTS]: ContentsRuleModel,
	[SearchType.CUSTOM]: CustomRuleModel,
	[SearchType.DATE]: DateRuleModel,
	[SearchType.EXPIRE]: ExpirationRuleModel,
	[SearchType.FILE_ASPECT]: FileAspectRuleModel,
	[SearchType.FILE_FORMAT]: FileFormatRuleModel,
	[SearchType.FILE_FORMAT_FAMILY]: FileFormatFamilyRuleModel,
	[SearchType.FILE_SIZE]: FileSizeRuleModel,
	[SearchType.KEYWORD]: KeywordRuleModel,
	[SearchType.METADATA]: MetadataRuleModel,
	[SearchType.AI]: AIRuleModel,
	[SearchType.SAVED_SEARCH]: SavedSearchRuleModel,
	[SearchType.USER]: UserRuleModel,
	[SearchType.VISUAL]: VisualRuleModel,
};

export const getRuleModel = (type: SearchType) => RuleModelMap[type];

export default getRuleModel;
